import { globalInfo } from "../../share/env/util"

/**
 * /**
 * @dtsModule max.gray
 * @dtsNamespace gray
 * @dtsDesc 灰度
 */
export const gray = {
  /**
   * @dtsExport
   */
  setTagValue(value: string): void {
    if (!value || typeof value !== 'string') return
    const grayConfig = globalInfo.get('grayConfig')
    if (grayConfig && grayConfig?.switching === 'ON' && grayConfig?.key) {
      // 默认两个月有效期
      const expires = new Date()
      expires.setDate(expires.getDate() + 60)
      cookieStore.set({
        name: grayConfig.key,
        value: value,
        expires: expires.getTime()
      })
    }
  }
}